import { deleteFormRequest, stopFormRequest, logicDeleteFormRequest, copyForm } from 'index/api/project/form'
import dayjs from 'dayjs'

export default {
  props: [],
  data() {
    return {
      folderId: 0,
      projectStatusList: [
        { code: '', name: '全部', color: '#006EFF' },
        { code: 1, name: '待发布', color: '#909399' },
        { code: 2, name: '收集中', color: '#409EFF' },
        { code: 3, name: '已停止', color: '#F56C6C' }
      ],
      projectTypeList: [
        { code: '', name: '全部', color: '#006EFF' },
        { code: 1, name: '问卷调查', color: '#409eff' },
        { code: 2, name: '收集表单', color: '#722ed1' },
        { code: 3, name: '考试测评', color: '#00b42a' },
        { code: 4, name: '360评估', color: '#14c9c9' },
        { code: 5, name: '营销表单', color: '#ff7a45' }
      ]
    }
  },
  filters: {
    formatDate(time) {
      return dayjs(time).format('YYYY/MM/DD')
    }
  },
  computed: {
    hasBzmjPermission() {
      const permissions = this.$store?.state?.permissions || []
      return permissions.some(uri => uri.startsWith('/bzmj') || uri === '/')
    }
  },
  methods: {
    getType(key) {
      // 使用 == 进行比较，兼容字符串和数字
      // 排除 code 为空字符串的项（即"全部"），避免空值匹配到"全部"
      const item = this.projectTypeList.find((e) => e.code !== '' && e.code == key)
      return item || { name: '-', color: '' }
    },
    logicDeleteForm(key) {
      logicDeleteFormRequest({ formKey: key }).then((res) => {
        if (res && res.data) {
          this.msgSuccess('刪除成功')
        }
      }).finally(() => {
        this.$emit('refresh')
      })
    },
    deleteForm(key) {
      deleteFormRequest({ formKey: key }).then((res) => {
        if (res && res.data) {
          this.msgSuccess('刪除成功')
        }
      }).finally(() => {
        this.$emit('refresh')
      })
    },
    stopProject(key) {
      stopFormRequest({ formKey: key }).then((res) => {
        if (res && res.data) {
          this.msgSuccess('停止成功')
        }
      }).finally(() => {
        this.$emit('refresh')
      })
    },
    toProjectHandle(form, type) {
      const query = { key: form.formKey, id: form.id, type: form.type }
      const qs = Object.keys(query)
        .filter(k => query[k] !== undefined && query[k] !== null)
        .map(k => `${k}=${encodeURIComponent(query[k])}`)
        .join('&')
      const map = {
        editor: '/survey/form',
        settings: '/survey/form/setting',
        publish: '/survey/form/publish',
        statistics: '/survey/form/statistics',
        content: '/survey/form/content'
      }
      const target = map[type] || '/survey/form'
      window.location.href = `${target}?${qs}`
    },
    async handleCopyForm(formKey) {
      try {
        const res = await copyForm(formKey)
        // 后端统一返回格式: { errcode: 0, Data: { formKey: "xxx" } }
        const data = res?.data?.Data || res?.data
        if (data && data.formKey) {
          this.$message.success('复制成功')
          // 刷新当前页面列表
          window.location.reload()
        } else {
          this.$message.warning('复制完成，但未获取到新问卷信息')
          window.location.reload()
        }
      } catch (err) {
        console.error('复制问卷失败:', err)
        this.$message.error(err?.message || '复制失败')
      }
    }
  }
}
